import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    karaokes: {
        data: [],
        pagination: {
            current_page: 1,
            total: 0,
        }
    },
    karaokeDiscJockeys: {},
    participators: [],
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
